
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { RoadmapForm } from "./RoadmapForm";
import { Bug } from "lucide-react";
import { useBrandManager } from "@/hooks/useBrandManager";

interface FloatingRoadmapWidgetProps {
  inline?: boolean;
}

export const FloatingRoadmapWidget = ({ inline = false }: FloatingRoadmapWidgetProps) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { currentBrand } = useBrandManager();

  // Only show for brand owners
  if (!currentBrand) {
    return null;
  }

  return (
    <>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setIsFormOpen(true);
        }}
        className={inline 
          ? "inline-flex h-6 w-6 rounded-full hover:bg-muted/80 transition-colors duration-200" 
          : "fixed bottom-4 right-4 h-8 w-8 rounded-full shadow-sm hover:shadow-md transition-all duration-200 bg-muted hover:bg-muted/80"
        }
        style={inline ? {} : { zIndex: 99999 }}
        variant={inline ? "ghost" : "default"}
        title="Report bug or request feature"
      >
        <Bug className="h-4 w-4" />
      </Button>
      
      <RoadmapForm 
        open={isFormOpen} 
        onOpenChange={setIsFormOpen}
      />
    </>
  );
};
